'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".TextInput-module_container__QXVA9{height:2.5rem;overflow-x:hidden;position:relative;width:100%}.TextInput-module_input__I8TSn{background-color:transparent;border:.0625rem solid #999;border-radius:.125rem;box-sizing:border-box;color:#000;cursor:text;font-size:.875rem;height:2.5rem;padding:.75rem .75rem .75rem .5rem;text-align:left;width:100%}.TextInput-module_input__I8TSn:focus{border-color:#111;outline-width:0;outline:none}.TextInput-module_inputActive__GZu-8{padding:1.25rem .75rem .25rem .5rem}.TextInput-module_disabled__mYiM9{border-color:#e0e0e0;color:#e0e0e0;cursor:auto}.TextInput-module_centeredStyle__WtopJ{padding-left:0;padding-right:0;text-align:center}";
var styles = {"container":"TextInput-module_container__QXVA9","input":"TextInput-module_input__I8TSn","inputActive":"TextInput-module_inputActive__GZu-8","disabled":"TextInput-module_disabled__mYiM9","centeredStyle":"TextInput-module_centeredStyle__WtopJ"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
